import { render, staticRenderFns } from "./GuideScene.vue?vue&type=template&id=4483f7f0&scoped=true&"
import script from "./GuideScene.vue?vue&type=script&lang=js&"
export * from "./GuideScene.vue?vue&type=script&lang=js&"
import style0 from "./GuideScene.vue?vue&type=style&index=0&id=4483f7f0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4483f7f0",
  null
  
)

export default component.exports